const Blank = ({ span }) =>
    <div style={{background:'white',gridColumn:
        span
            ? `${4 - span} / -1`
            : undefined}}></div>

export default Blank